import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IReportRequest, IReturnSummaryByProduct } from '../models/models'

export class GetOrderReportByProductApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/returnReport/ReturnReportsByProduct',
      requesterInfo,
    })
  }

  public async getReport(req: IReportRequest): Promise<IReturnSummaryByProduct[]> {
    return await this.postAsync<IReturnSummaryByProduct[]>(req)
  }
}
